export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5018.66380de1.jpg";